<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <px-aprovacao-solicitacao-geracao-parcial-dialog :aprovacao-id="aprovacao.id">
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on">
            <v-list-item-content>Gerar solicitação parcial</v-list-item-content>
          </v-list-item>
        </template>
      </px-aprovacao-solicitacao-geracao-parcial-dialog>
    </v-list>
  </v-menu>
</template>

<script>
import AprovacaoSolicitacaoGeracaoParcialDialog
  from '@/modules/aprovacao-solicitacao/geracao-parcial/AprovacaoSolicitacaoGeracaoParcialDialog.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  components: {
    pxAprovacaoSolicitacaoGeracaoParcialDialog: AprovacaoSolicitacaoGeracaoParcialDialog,
  },
};
</script>
